import { CommonDataSharedService } from 'app/services/commonDataSharedService';
import { CommonService } from 'app/services/common.service';
import { CommonRequestResponseService } from './../../services/common-request-response.service';
import { CommonAuthenticationService } from './../../services/common-authentication.service';
import { EnvService } from './../../services/env.service';
import { NotificationService } from './../../services/notification.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { StudentDocumentsComponent } from '../student-documents/student-documents.component';
import { NgForm } from '@angular/forms';

import { Router } from '@angular/router';
import { DraggableModalService } from '../shared/draggable-modal/draggable-modal.service';
import { ConfirmModalService } from '../shared/confirm-modal/confirm-modal.service';

@Component({
  selector: 'app-student-document-upload',
  templateUrl: './student-document-upload.component.html',
  styleUrls: ['./student-document-upload.component.scss']
})
export class StudentDocumentUploadComponent extends StudentDocumentsComponent implements OnInit {
  @ViewChild('from') form: NgForm;
  documentClasses: any;
  documents: any;
  studentUserId;
  constructor(
    private notificationServices: NotificationService,
    private envServices: EnvService,
    private _commonAuthServices: CommonAuthenticationService,
    private _commonRequestResponseServices: CommonRequestResponseService,
    private _commonServices: CommonService,
    private _commonDataSharedServices: CommonDataSharedService,
    public _routers: Router,
    private draggableModalServices: DraggableModalService,
    private confirmModalServices: ConfirmModalService
  ) {
    super(notificationServices, envServices, _commonAuthServices, _commonRequestResponseServices, _commonServices, _commonDataSharedServices, _routers, draggableModalServices, confirmModalServices);
  }

}
